import { render, staticRenderFns } from "./DataTableSkeletonLoader.vue?vue&type=template&id=a80da934&"
import script from "./DataTableSkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./DataTableSkeletonLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports